var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23549_41481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99342 10.4099C5.44134 10.4099 4.90165 10.5736 4.44261 10.8803C3.98357 11.1871 3.62579 11.623 3.41452 12.1331C3.20324 12.6431 3.14797 13.2044 3.25567 13.7459C3.36338 14.2873 3.62923 14.7847 4.01961 15.1751C4.41 15.5655 4.90737 15.8313 5.44885 15.939C5.99033 16.0467 6.55158 15.9915 7.06164 15.7802C7.5717 15.5689 8.00766 15.2111 8.31438 14.7521C8.6211 14.2931 8.78481 13.7534 8.78481 13.2013C8.78397 12.4612 8.48961 11.7517 7.96631 11.2284C7.443 10.7051 6.73349 10.4107 5.99342 10.4099ZM9.25465 10.4098C8.70256 10.4098 8.16288 10.2461 7.70384 9.93934C7.24479 9.63262 6.88702 9.19667 6.67574 8.68661C6.46447 8.17655 6.40919 7.61529 6.5169 7.07382C6.6246 6.53234 6.89045 6.03496 7.28084 5.64458C7.67122 5.2542 8.1686 4.98834 8.71007 4.88064C9.25155 4.77293 9.81281 4.82821 10.3229 5.03948C10.8329 5.25076 11.2689 5.60854 11.5756 6.06758C11.8823 6.52662 12.046 7.0663 12.046 7.61839C12.0452 8.35845 11.7508 9.06797 11.2275 9.59127C10.7042 10.1146 9.99471 10.4089 9.25465 10.4098ZM2.79139 10.4099C2.2393 10.4099 1.69962 10.2462 1.24058 9.93946C0.781536 9.63274 0.423757 9.19678 0.212483 8.68672C0.00120947 8.17666 -0.0540693 7.61541 0.053637 7.07393C0.161343 6.53246 0.427197 6.03508 0.81758 5.64469C1.20796 5.25431 1.70534 4.98846 2.24682 4.88075C2.78829 4.77305 3.34955 4.82833 3.85961 5.0396C4.36967 5.25087 4.80562 5.60865 5.11234 6.06769C5.41906 6.52673 5.58278 7.06642 5.58278 7.6185C5.58194 8.35857 5.28758 9.06808 4.76427 9.59139C4.24097 10.1147 3.53145 10.4091 2.79139 10.4099Z",
    fill: "#F7AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.567 5.25C12.7594 5.58333 13.2406 5.58333 13.433 5.25L15.1651 2.25C15.3575 1.91667 15.117 1.5 14.7321 1.5H11.2679C10.883 1.5 10.6425 1.91667 10.8349 2.25L12.567 5.25Z",
    fill: "#F7AE4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23549_41481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpore);
export default __webpack_public_path__ + "static/media/spore.ef642a26ce430ff8ed10682d3f98b896.svg";
export { ForwardRef as ReactComponent };